import * as tslib_1 from "tslib";
import createGenericItem from './createGenericItem';
import getSuggestedContacts from './getSuggestedContacts';
import getSuggestions from './getSuggestions';
import FindResultRecipient from '../components/FindResultRecipient';
import convertPersonaToRecipientPersonaProps from '../utils/convertPersonaToRecipientPersonaProps';
import getSuggestionProps from '../utils/getSuggestionProps';
import pauseSession from 'owa-controls-findpeople-feedback-manager/lib/actions/pauseSession';
import resumeSession from 'owa-controls-findpeople-feedback-manager/lib/actions/resumeSession';
import isValidEmailAddress from 'owa-readwrite-recipient-well/lib/utils/isValidEmailAddress';
import { SuggestionsStore, } from 'office-ui-fabric-react/lib/FloatingPicker';
export default function getFloatingPickerProps(getViewState, getFindControl) {
    return {
        suggestionsStore: new SuggestionsStore(),
        onValidateInput: isValidEmailAddress,
        onRenderSuggestionsItem: onRenderSuggestion(getViewState, getFindControl),
        createGenericItem: createGenericItem,
        onResolveSuggestions: getQuerySuggestions(getViewState()),
        onZeroQuerySuggestion: getZeroQuerySuggestions(getViewState()),
        calloutWidth: 300,
        resolveDelay: 150,
        getTextFromItem: function (item) {
            return item.persona.EmailAddress.Name;
        },
        pickerSuggestionsProps: getSuggestionProps(getViewState, getFindControl),
        onSuggestionsShown: onSuggestionsShown(getViewState()),
        onSuggestionsHidden: onSuggestionsHidden(getViewState()),
    };
}
function onRenderSuggestion(getViewState, getFindControl) {
    return function (props, itemProps) {
        return FindResultRecipient({
            viewState: getViewState(),
            itemProps: itemProps,
            persona: props.persona,
            onMaskRecipient: onMaskRecipient(getFindControl()),
        });
    };
}
function onMaskRecipient(findControl) {
    return function (viewState) {
        findControl.updateSuggestions(convertPersonaToRecipientPersonaProps(viewState.findResultSet), true /*updateUI*/);
    };
}
function getQuerySuggestions(viewState) {
    return function (filterText, recipients) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getSuggestions(filterText, viewState, recipients)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
}
function getZeroQuerySuggestions(viewState) {
    return function (recipients) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getSuggestedContacts(viewState, recipients)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
}
function onSuggestionsShown(viewState) {
    return function () {
        resumeSession(viewState.findPeopleFeedbackManager);
    };
}
function onSuggestionsHidden(viewState) {
    return function () {
        pauseSession(viewState.findPeopleFeedbackManager);
    };
}
//# sourceMappingURL=getFloatingPickerProps.js.map